// Studio (creator dashboard) config. Same Supabase project as the
// boards; the anon/publishable key is safe in the browser.
export const STUDIO_CONFIG = {
  supabaseUrl: "https://tetrbmzyrlkvitmutilv.supabase.co",
  supabaseAnonKey: "sb_publishable_ElYhspJicy2ts4XGhUL4Hw_e_7iPxHF",
  // where a freshly-created guest board lives
  guestBase: "https://memorybox.pages.dev/b/",
};
